import React, { useEffect, useState, useGlobal, useRef } from "reactn";
import PropTypes from "prop-types";
import SwitchProfileButton from "shared-anpost-components/components/SwitchProfile/SwitchProfileButton";
import { MobileTopBarStyled } from "./MobileTopBar.styled";
import AppHook from "../../../hooks/appHook";
import MagnifyIcon from "../../../images/magnify.svg";

const MobileTopBar = ({ isOverview, history }) => {
	const [dropdownExpanded, setDropdownExpanded] = useState(false);
	const { copyTopMobileDropdowns, setNavProfileLinks } = AppHook();
    const topBarRef = useRef(null);
    const [mobileNav] = useGlobal("mobileNav");

    useEffect(() => {
        window.MobileMenu && window.MobileMenu.init();
		copyTopMobileDropdowns();
    }, []);

	useEffect(() => {
        dropdownExpanded && closeBurgerMenu();

		// close account menu if expanded when burger menu opens
		document.addEventListener("burgerOpen", () => {
			if (dropdownExpanded) {
				setDropdownExpanded(false);
			}
		});
    }, [dropdownExpanded]);

	useEffect(() => {
        const mobileNavigation = topBarRef.current;
        if (!mobileNavigation) return;
		const basketButton = mobileNavigation.querySelector(".header__basket a");
		const basketModal = mobileNavigation.querySelector(".m58");
		const basketCloseModalBtn = mobileNavigation.querySelector(".m58__close__wrapper");
		const dropdownLinks = mobileNavigation.querySelectorAll(".m59__list.user li a");
		if (!basketButton || !basketCloseModalBtn || dropdownLinks.length === 0) return;
		basketButton.setAttribute("aria-expanded", "false");

        basketButton.addEventListener("click", e => {
			e.preventDefault();
			basketModal.classList.add("m58--open");
			basketButton.setAttribute("aria-expanded", "true");
        });

		basketCloseModalBtn.addEventListener("click", () => {
			basketModal.classList.remove("m58--open");
			basketButton.setAttribute("aria-expanded", "false");
        });

        dropdownLinks.forEach(el => {
            el.classList.remove("gtm-header");
            el.classList.add("gtm-headerMACH");
        });

		setNavProfileLinks(dropdownLinks, history);
    }, [mobileNav]);

	const closeBurgerMenu = () => {
		const burger = document.querySelector(".header:not(.header--mach) .js-header__burger");
		burger.classList.contains("header__burger__open") && burger.click();
	}

	const renderLogo = () => {
		return (
			<a href="/" className="header__logo__img gtm-logo" title="Go back to the homepage">
				<svg width="52" height="32" fill="none" xmlns="http://www.w3.org/2000/svg">
					<path
						d="M28.193 5.705v7.385h-3.465V5.903c0-1.795-.822-2.683-2.383-2.683-1.237 0-2.324.618-2.918 1.963v7.907h-3.464V.357h2.992l.262 1.693C20.07.675 21.474 0 23.18 0c3.081 0 5.013 1.87 5.013 5.705ZM14.097 21.986c0 4.049-2.834 6.85-6.64 6.85-1.535 0-2.729-.458-3.595-1.413L3.888 32H.424V15.746H3.39l.301 1.656c.971-1.388 2.468-2.012 4.239-2.012 3.726 0 6.167 2.852 6.167 6.596Zm-3.634.127c0-2.126-1.365-3.616-3.426-3.616-1.522 0-2.69.828-3.188 2.139l.013 3.272c.55 1.121 1.653 1.822 3.044 1.822 2.06 0 3.557-1.49 3.557-3.617ZM36.693 20.879l-.89-.28c-1.468-.457-1.965-.737-1.965-1.347 0-.585.576-.916 1.99-.916 1.073 0 2.152.18 3.24.58l.477-2.959c-1.257-.424-2.402-.544-3.873-.544-3.25 0-5.293 1.627-5.293 3.89 0 2.084 1.205 3.28 3.668 4.067l.786.255c1.415.457 1.991.788 1.991 1.322 0 .533-.471.966-1.912.966-1.363 0-2.856-.534-3.93-1.093l-.708 2.898c1.206.66 2.883 1.119 4.611 1.119 3.433 0 5.398-1.628 5.398-3.967 0-2.059-1.022-3.178-3.59-3.991ZM13.672.357V13.09h-3.15l-.038-1.642c-.853 1.26-2.126 2-4.094 2-3.7 0-6.39-2.98-6.39-6.723C0 2.954 2.73 0 6.508 0c1.784 0 3.031.586 3.91 1.846l.184-1.49h3.07ZM10.208 8.38v-3.31c-.525-1.21-1.614-1.961-3.018-1.961-2.06 0-3.556 1.49-3.556 3.616 0 2.126 1.496 3.616 3.556 3.616 1.404 0 2.493-.752 3.018-1.961Z"
						fill="#fff"
					/>
					<path
						d="M20.595 27.1c2.838 0 5.14-2.233 5.14-4.987 0 1.794-1.5 3.248-3.348 3.248-1.849 0-3.347-1.454-3.347-3.248 0-2.754 2.3-4.987 5.139-4.987 2.838 0 5.139 2.233 5.139 4.987 0-3.714-3.103-6.726-6.931-6.726s-6.93 3.012-6.93 6.726c0 2.754 2.3 4.987 5.138 4.987Z"
						fill="url(#a)"
					/>
					<path
						d="M24.179 17.126c-2.838 0-5.14 2.233-5.14 4.987 0-1.794 1.5-3.248 3.348-3.248 1.849 0 3.347 1.454 3.347 3.248 0 2.754-2.3 4.987-5.139 4.987-2.838 0-5.139-2.233-5.139-4.987 0 3.715 3.103 6.726 6.931 6.726s6.931-3.011 6.931-6.726c0-2.754-2.301-4.987-5.14-4.987Z"
						fill="url(#b)"
					/>
					<path
						d="M50.906 25.275c-.544.137-1.23.206-1.915.206-2.34 0-3.12-1.101-3.12-3.648 0-.848.07-1.835.212-2.89h4.823v-3.19h-4.28a41.86 41.86 0 0 1 .828-3.28h-3.688c-.307 1.032-.567 2.157-.804 3.28h-1.82l-.497 3.19h1.845a27.41 27.41 0 0 0-.19 3.051c0 4.359 1.963 6.768 6.597 6.768.969 0 1.749-.092 2.411-.298l-.402-3.19Z"
						fill="#fff"
					/>
					<defs>
						<linearGradient id="a" x1="20.067" y1="17.338" x2="23.004" y2="25.168" gradientUnits="userSpaceOnUse">
							<stop stopColor="#fff" />
							<stop offset=".6" stopColor="#fff" stopOpacity=".88" />
							<stop offset="1" stopColor="#fff" stopOpacity=".15" />
						</linearGradient>
						<linearGradient id="b" x1="24.152" y1="27.007" x2="21.945" y2="19.017" gradientUnits="userSpaceOnUse">
							<stop stopColor="#fff" />
							<stop offset=".6" stopColor="#fff" stopOpacity=".88" />
							<stop offset="1" stopColor="#fff" stopOpacity=".15" />
						</linearGradient>
					</defs>
				</svg>
			</a>
		);
	};

    return (
        <MobileTopBarStyled className="header" ref={topBarRef}>
			{renderLogo()}
            <div className="header__mobile-controls">
				<>
					<div className="header__basket" dangerouslySetInnerHTML={mobileNav?.basketButton}></div>
					<div dangerouslySetInnerHTML={mobileNav?.basketDropdown}></div>
					<div className={`m59 m59--myap dropdown ${dropdownExpanded ? "expanded" : ""}`}>
						<button type="button" className="m59__trigger dropdown__expand-bn gmt-headerMACH" 
							aria-label="My account" 
							onClick={() => setDropdownExpanded(!dropdownExpanded)} 
							aria-expanded={dropdownExpanded}>
							<span data-m59-username="">My account</span>
						</button>
						<div data-m59-dropdown="" className="m59__dropdown dropdown__list">
							<SwitchProfileButton mobile isOverview={isOverview} className="gmt-headerMACH"></SwitchProfileButton>
							<div dangerouslySetInnerHTML={mobileNav?.userMenu}></div>
						</div>
					</div>
				</>
                <a href="/Search" className="header__utility-search gtm-header">
                    <img src={MagnifyIcon} alt="Search" />
                </a>
                <button type="button" className="header__burger js-header__burger" aria-label="Open Menu">
                    <span className="header__burger__icon"></span>
                </button>
            </div>
        </MobileTopBarStyled>
    );
};

MobileTopBar.propTypes = {
    isOverview: PropTypes.bool,
    history: PropTypes.object
};

export default MobileTopBar;
